import React from "react";
import "./index.css";
import julia from "./IMG_3101.webp";
import leo from "./IMG_1711.JPG";
import evgeni from "./photo_3_2025-05-28_19-32-35.jpg";

const guides = [
  {
    name: "Лео",
    photo: leo,
    description:
      "Лео — наш основной гид и человек, который буквально живёт в горах.\n\n Любовь к походам у него с детства: всё началось с первых выходов с отцом.\n\n С октября 2023 года Лео живёт в Грузии и полностью погружён в местный рельеф. С апреля 2024 по июль 2025 он успел пройти 100+ походов, в основном по Аджарии, но также по Гурии и Сванетии. Он не просто ходит — он изучает, сравнивает, систематизирует и строит планы.\n\n Из самых ярких, уже состоявшихся, вызовов:\n – Местия — Ушгули за день: 56 км и 3000 м набора/сброса,\n – Три с половиной круга Гулеби за 10 часов: 50 км, 3000 м перепада,\n – Веломаршрут Батуми — Кеда — Батуми: 100 км и почти без остановок.\n\n В походах — спокойный, стрессоустойчивый и включённый. Несколько раз оказывался в ситуациях с вызовом МЧС и сохранял хладнокровие.\n\n Особенно горит маршрутами на выносливость — и процессом их планирования. Готов идти долго, далеко и высоко!",
  },
  {
    name: "Юля",
    photo: julia,
    description:
      "Юля — наш новый гид, инструктор, организатор и душа команды. Родом из Беларуси, в туризме — с детства. С 2017 года профессионально водит походы, сплавы и приключенческие маршруты. \n\nЗа плечами — десятки категорийных маршрутов в Беларуси и Украине, горные треки на Кавказе, мото и автопутешествия. Работает как с новичками, так и с опытными участниками. Умеет сделать так, чтобы каждому в группе было комфортно — независимо от уровня подготовки.\n\n Проходит регулярное обучение и бросает себе вызовы, с ней вы всегда в надёжных руках.\n\n Юля не просто проводит по маршруту, а создаёт атмосферу доверия и сплочённости. Каждое путешествие с ней — это не только про горы, но и про людей: про смех у костра, про честные разговоры, про чувство «я на своём месте».\n\n Если вы ищете не просто гида, а человека, который умеет вдохновлять, слышать и вести за собой — Юля именно та, с кем стоит отправиться в путь.",
  },
  {
    name: "Евгений",
    photo: evgeni,
    description:
      "Евгений — наш проводник, в котором сочетаются надёжность, выносливость и здоровое чувство юмора. 2000 года выпуска, родом из Челябинской области, где и прошёл первые километры по горам — Таганай, Зюраткуль и другие хребты Южного Урала.\n\n Позже Евгений переехал в Кыргызстан — и влюбился в горы повыше. Ала-Кёль, Алтын-Арашан и другие маршруты стали для него привычным рельефом. Там же вместе с командой он открыл сап-пункт на высокогорном озере, доставляя доски пешком. Организация, лагерь, логистика, безопасность — всё на его плечах, в прямом и переносном смысле.\n\n Он всегда подстрахует, поддержит и вовремя подбодрит — иногда с иронией.\nВне походов — занимается спортом, бегает, ходит в зал, а порой и выступает на стендап-микрофонах. Да, даже у костра. И да, с юмором.",
  },
];

export const GuidesSection = () => {
  return (
    <section className="guides-section">
      <h2 className="guides-title">Наши гиды</h2>
      <div className="guides-list">
        {guides.map((guide, idx) => (
          <div key={idx} className="guide-card">
            <img src={guide.photo} alt={guide.name} className="guide-photo" />
            <h3 className="guide-name">{guide.name}</h3>
            <p className="guide-description">{guide.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
